export default class itemPlannerSelector {

    constructor() {
        this.clearSelection();
    }

    getSelectionItems() {
        return this.selection;
    }

    getDragItem() {
        return this.selection[0];
    }

    getSelectionLength() {
        return this.selection.length;
    }

    getSelectionIds() {
        return _.map(this.selection, 'id');
    }

    clearSelection() {
        this.selection = [];
    }

    getItemIndexFromSelection(itemId) {
        return _.findIndex(this.selection, {id: itemId});
    }

    toggleSelectionValue(item) {
        if (this.inSelection(item.id)) {
            this.removeFromSelection(item);
        } else {
            this.addToSelection(item);
        }
    }

    addItemWhenNotInSelection(item, unshiftItem = false) {
        if (!this.inSelection(item.id)) {
            this.addToSelection(item, unshiftItem);

        } else if (unshiftItem) {
            this.removeFromSelection(item);
            this.addToSelection(item, true);
        }
    }

    inSelection(itemId) {
        return this.getItemIndexFromSelection(itemId) !== -1;
    }

    addToSelection(item, unshiftItem = false) {
        if (unshiftItem) {
            this.selection.unshift(item);
        } else {
            this.selection.push(item);
        }
    }

    removeFromSelection(item) {
        const index = this.getItemIndexFromSelection(item.id);
        if (index !== -1) this.selection.splice(index, 1);
    }

}

itemPlannerSelector.$inject = [];
